import { createEntity as createEntityApi, readEndpoint } from 'redux-json-api';
import types from '../constants/actionTypes'
import { displayError, clearMessages } from './messagesActions';

const startDownload = (type) => {
  return {
    type: types.START_DOWNLOAD,
    entityType: type
  };
};

const downloadSuccess = (downloadUrl) => {
  return {
    type: types.DOWNLOAD_SUCCESS,
    downloadUrl
  }
};

const downloadFail = (errorMessage) => {
  return {
    type: types.DOWNLOAD_FAIL,
    errorMessage
  }
};

const reportTimeout = () => {
  return {
    type: types.REPORT_TIMEOUT
  }
}

export const endTimeout = () => {
  return {
    type: types.END_TIMEOUT
  }
}

export const pollUrl = (interval, max, getData, checkComplete, onFinish, onTimeout) => {
  let timer = 0;
  let poll = setInterval(async () => {
    if (timer > max){
      clearInterval(poll);
      onTimeout();
    } else {
      timer += interval;
      let status = await getData();
      if (checkComplete(status)){
        clearInterval(poll);
        onFinish(status);
      }
    }
  }, interval);
  return poll;
};

export const downloadReport = (type, attributes) => {
  attributes.report_type = type;
  let dl = { type: 'reports', attributes };
  return async function(dispatch, getState){
    dispatch(startDownload());
    let create = createEntityApi(dl);
    try {
      let report = await create(dispatch, getState);
      dispatch(clearMessages());
      pollUrl(1000, 11000,
        async () => await dispatch(readEndpoint(`reports/${report.data.id}`)),
        (status) => status.data.attributes.status === 'completed',
        (result) => dispatch(downloadSuccess(result.data.attributes.download_url)),
        () => dispatch(reportTimeout())
      );
    } catch (e) {
      dispatch(displayError(e));
      dispatch(downloadFail());
    }
  }
};

export const fetchReport = id => {
  return async function(dispatch) {
    dispatch(startDownload());
    try {
      const result = await dispatch(readEndpoint(`reports/${id}`));
      dispatch(downloadSuccess(result.data.attributes.download_url));
    } catch (e) {
      dispatch(displayError(e));
      dispatch(downloadFail());
    }
  }
};
